/* eslint-disable no-magic-numbers */
import { ReactNode } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DialogProps } from '@mui/material/Dialog';
import { Close as CloseIcon } from '@mui/icons-material';
import CSS from 'csstype';

import Loader from '~/components/Loader';
import { useTrans, useNonHookTrans } from "~/hooks/useTrans";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
		padding: theme.spacing(2),
	},
	'& .MuiDialogActions-root': {
		padding: theme.spacing(1),
	},
}));

interface DialogTitleProps {
	id: string;
	children?: ReactNode;
	onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
	const { children, onClose, ...other } = props;

	return <DialogTitle sx={{ m: 0, p: 2, fontWeight: "bold" }} {...other}>
		{children}
		<IconButton
			aria-label="close"
			onClick={onClose}
			sx={{
				position: 'absolute',
				right: 8,
				top: 8,
				color: "#008000",
			}}
		>
			<CloseIcon />
		</IconButton>
	</DialogTitle>;
};

interface IDialog extends Omit<DialogProps, "open"> {
	title?: string;
	contentSx?: CSS.Properties;
	children?: ReactNode;
	onClose?: () => void;
	props?: DialogProps;
	errorMsg?: string;
	dialogLoading?: boolean;
	cancelCaption?: string;
	minWidth?: string;
}

export default function MyAlert({
	title = "",
	className = "",
	contentSx = {},
	children = null,
	onClose = () => {},
	errorMsg = "",
	dialogLoading = false,
	cancelCaption = useNonHookTrans().trans("cancelChanges"),
	minWidth = "400px",
	...props
}: IDialog) {
	const { trans } = useTrans();

	function closeDialog() {
		if (!dialogLoading) {
			onClose();
		}
	}

	return <BootstrapDialog
		onClose={closeDialog}
		open={true}
		className={className}
		{ ...props }
	>
		<BootstrapDialogTitle id="save-dialog-title" onClose={closeDialog}>
			{ title }
		</BootstrapDialogTitle>
		<DialogContent dividers style={{ padding: "32px", minWidth, maxWidth: "90%" }} sx={contentSx}>
			{children}
			<p className="myDialog__info">{ errorMsg }</p>
			{ dialogLoading && <Loader msg={trans("loadingData")} /> }
		</DialogContent>
		<DialogActions style={{ justifyContent: "end", padding: "16px 32px" }}>
			<Button autoFocus onClick={closeDialog} variant="outlined" color="success" style={{ textTransform: "none" }}>
				{ cancelCaption }
			</Button>
		</DialogActions>
	</BootstrapDialog>;
}
